import { OnlyInStock } from "../enums/OnlyInStock.enum";

export const ONLY_IN_STOCK_OPTIONS = [
  OnlyInStock.ViewAll,
  OnlyInStock.CountryRegionStock,
  OnlyInStock.MyStoreStock
]

export const ONLY_IN_STOCK_FIELD = "OnlyInStock";
export const ONLY_IN_STORE_FIELD = "OnlyInStore";
